import { IntlShape } from 'react-intl';

export const getSourceFilterDateOptions = (intl: IntlShape) => [
  { value: 'CREATED', label: intl.formatMessage({ id: 'STUDIO.LABEL.SOURCE_DATE_VALUE_CREATED' }) },
  { value: 'STARTED', label: intl.formatMessage({ id: 'STUDIO.LABEL.SOURCE_DATE_VALUE_STARTED' }) },
  { value: 'ENDED', label: intl.formatMessage({ id: 'STUDIO.LABEL.SOURCE_DATE_VALUE_ENDED' }) },
];

export const getFilterDateOptions = (intl: IntlShape) => [
  { value: 'TODAY', label: intl.formatMessage({ id: 'STUDIO.LABEL.RANGE_DATE_VALUE_TODAY' }) },
  { value: 'YESTERDAY', label: intl.formatMessage({ id: 'STUDIO.LABEL.RANGE_DATE_VALUE_YESTERDAY' }) },
  { value: 'LAST_WEEK', label: intl.formatMessage({ id: 'STUDIO.LABEL.RANGE_DATE_VALUE_LAST_WEEK' }) },
  { value: 'THIS_WEEK', label: intl.formatMessage({ id: 'STUDIO.LABEL.RANGE_DATE_VALUE_THIS_WEEK' }) },
  { value: 'LAST_MONTH', label: intl.formatMessage({ id: 'STUDIO.LABEL.RANGE_DATE_VALUE_LAST_MONTH' }) },
  { value: 'THIS_MONTH', label: intl.formatMessage({ id: 'STUDIO.LABEL.RANGE_DATE_VALUE_THIS_MONTH' }) },
  { value: 'LAST_YEAR', label: intl.formatMessage({ id: 'STUDIO.LABEL.RANGE_DATE_VALUE_LAST_YEAR' }) },
  { value: 'THIS_YEAR', label: intl.formatMessage({ id: 'STUDIO.LABEL.RANGE_DATE_VALUE_THIS_YEAR' }) },
];

export const getAllOption = (title: string, intl: IntlShape) => [
  { label: intl.formatMessage({ id: "FORM.LABEL.ALL" }, { title }), value: 'all' },
]
